import { FeatureCode } from '@core/feature-spec-types';
import type { BadgeColor } from '@core/user-interface-legacy';

export enum FeatureGuardMode {
  Dialog = 'dialog',
  Redirect = 'redirect',
}

export interface FeatureGuardComponent {
  mode: FeatureGuardMode;
  feature: string;
}

export type UpsellBadgeConfig = {
  label: string;
  tooltip: string;
  color: BadgeColor;
} | null;

// If you need to add a new guarded feature, add it to FeatureCode from @recruitee/feature-spec-types
export { FeatureCode as GuardedFeature };

// TODO remove this enum when the issue described below is resolved
// This exists because we currently don't have a proper way to inspect functionality on other plans
// if the same feature behaves differently on different plans (eg. different limits of custom fields)
// DO NOT USE THIS IF NOT NECESSARY
export enum FrontendOnlyGuardedFeature {
  UnlimitedCustomFields = 'unlimitedCustomFields',
  WorkflowAutomationsNewPlans = 'workflowAutomationsNewPlans',
  WorkflowAutomationsLaunchNewPlans = 'workflowAutomationsLaunchNewPlans',
  WorkflowAutomationsAdvance = 'WorkflowAutomationsAdvance',
  WorkflowAutomationsOptimize = 'workflowAutomationsOptimize',
  UnlimitedJobPageLayouts = 'unlimitedJobPageLayouts',
}
